/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_More_Selected_OrdersInputs */

const en_orders_more_selected_orders = /** @type {(inputs: Orders_More_Selected_OrdersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more selected order(s)`)
};

const es_orders_more_selected_orders = /** @type {(inputs: Orders_More_Selected_OrdersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} pedido(s) seleccionados mas`)
};

/**
* | output |
* | --- |
* | "+{count} more selected order(s)" |
*
* @param {Orders_More_Selected_OrdersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_more_selected_orders = /** @type {((inputs: Orders_More_Selected_OrdersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_More_Selected_OrdersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_more_selected_orders(inputs)
	return es_orders_more_selected_orders(inputs)
});